import { DataCollectionInterface } from '../../interfaces/data-collection.interface';

export class SaveDataCollection {
    public static readonly type = '[DataCollection] Save data collection';

    constructor(public dataCollection: DataCollectionInterface) { }
}
